import React from "react";
import {
    Box,
    Backdrop,
    Slide,
    Paper,
    IconButton,
    Typography,
    useMediaQuery
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../styles/theme';
import ProspectTourAvailability from './ProspectTourAvailability';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

interface ProspectTourAvailabilityOverlayProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    prospectId?: string;
}

const ProspectTourAvailabilityOverlay: React.FC<ProspectTourAvailabilityOverlayProps> = ({
    open,
    onClose,
    onSuccess,
    prospectId
}) => {
    const isDesktop = useMediaQuery('(min-width:960px)');
    return (
        <ThemeProvider theme={theme}>
            <Backdrop
                open={open}
                sx={{
                    zIndex: theme => theme.zIndex.drawer + 1,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                }}
                onClick={(e) => {
                    // Only close if the backdrop itself is clicked
                    if (e.target === e.currentTarget) {
                        onClose();
                    }
                }}
            >
                <Slide direction="up" in={open} mountOnEnter unmountOnExit>
                    <Box
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%'
                        }}
                    >
                        <Paper
                            sx={{
                                p: 0,
                                borderRadius: 6,
                                width: isDesktop? '66%' : '100%',
                                maxWidth:  isDesktop? '66%' :'100%',
                                maxHeight: '90vh',
                                overflowY: 'auto',
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                                margin: isDesktop ? 'auto' : 0,
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'sticky',
                                    top: 0,
                                    left: 0,
                                    backgroundColor: 'background.paper',
                                    zIndex: 2,
                                    px: 3,
                                    py: 2,
                                    minHeight: 64,
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Box display="flex" alignItems="center" mb={0} pr={4} flex={1}>
                                    <CalendarMonthOutlinedIcon sx={{ color: 'black', mr: 1, fontSize: 40 }} />
                                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                                        Set Your Availability
                                    </Typography>
                                </Box>
                                <IconButton
                                    onClick={onClose}
                                    sx={{
                                        position: 'static',
                                        ml: 1,
                                        zIndex: 4,
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                            <ProspectTourAvailability onClose={onClose} onSuccess={onSuccess} prospectId={prospectId} />
                        </Paper>
                    </Box>
                </Slide>
            </Backdrop>
        </ThemeProvider>
    );
};

export default ProspectTourAvailabilityOverlay;
